export default __webpack_public_path__ + "images/SpeakersPhotos/Biladi Lujan Sakudarte.jpg?9fdf833e";